import { Card, Heading, Text } from "@/design-system";
import { IntegrationLogo } from "./integrationLogo";
import { IntegrationMethodBadges } from "./integrationMethodBadges";
import type { Integration } from "@/pages/landingPage/constants/integrations";

type IntegrationCardProps = {
  integration: Integration;
};

// `id` = âncora usada pelo menu "Integrações" do header; `scroll-mt-28`
// desconta o header fixo ao rolar até o card.
export const IntegrationCard = ({ integration }: IntegrationCardProps) => (
  <Card
    id={integration.slug}
    className="flex h-full scroll-mt-28 flex-col gap-4"
  >
    <div className="flex items-start justify-between gap-3">
      <IntegrationLogo initials={integration.initials} />
      <IntegrationMethodBadges methods={integration.methods} />
    </div>
    <div className="flex flex-col gap-1.5">
      <Heading level={3} size={4}>
        {integration.name}
      </Heading>
      <Text size="small" tone="subtle">
        {integration.description}
      </Text>
    </div>
  </Card>
);
